import { render } from "./ImageLoader.vue?vue&type=template&id=7c7b09c4"
import script from "./ImageLoader.vue?vue&type=script&lang=js"
export * from "./ImageLoader.vue?vue&type=script&lang=js"

import "./ImageLoader.vue?vue&type=style&index=0&id=7c7b09c4&lang=css"

import exportComponent from "/Users/marianne/DevProjects/Marinka backup 29-08-2025/full website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__